import { Component, OnInit } from '@angular/core';
import { DataTable, LazyLoadEvent, Message, SelectItem } from 'primeng/primeng';
import { NotificationContentType } from '../../models/inModels/MessageModel';
import { StorageService } from '../../services/system/storage.service';
import { Router } from '@angular/router';
import { CourierServiceResponse } from '../../models/inModels/MarketPlaceModel';
import { CouriersService } from '../../services/courier-services/couriers.service';

@Component({
  selector: 'app-courier-services',
  templateUrl: './courier-services.component.html',
})
export class CourierServicesComponent implements OnInit {
  rows: SelectItem[];
  items: CourierServiceResponse[];
  selectedRows: number;
  filteredRecords: number;
  rowEvent: LazyLoadEvent;
  loading: boolean;
  totalRecords: number;
  error: Message[];
  contentId: number;
  contentType: NotificationContentType;
  sendAllDialog = false;
  isEditMode: boolean = false;
  constructor(private service: CouriersService,
    public storageService: StorageService,
    private router: Router) {
      this.loading = true;
      this.rows = [];
      this.rows.push({ label: '10', value: 10 });
      this.rows.push({ label: '25', value: 25 });
      this.rows.push({ label: '50', value: 50 });
      this.selectedRows = 10;
  }

  ngOnInit() {
  }

  changeRows(event): void {
    this.load(this.rowEvent);
  }

  reset(dt: DataTable, gb: HTMLInputElement) {
    gb.value = '';
    dt.reset();
  }

  edit(group: CourierServiceResponse) {
    this.router.navigate(['marketplace/courier-services/edit', group.Id]);
  } 

  delete(option: CourierServiceResponse) {
    this.service.delete(option.Id.toString()).then(
      res => {
        this.items = this.items.filter(i => i.Id !== option.Id);
      },
      error => {
        this.loading = false;
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error });
      });
  } 

  load(event: LazyLoadEvent): void {
    this.loading = true;
    event.rows = this.selectedRows;
    this.rowEvent = event;
    this.service.search(event).then(
      dataPager => {
        this.items = dataPager.Data;
        this.filteredRecords = dataPager.FilteredRecords;
        this.totalRecords = dataPager.TotalRecords;
            this.loading = false;
      },
      error => {
        this.loading = false;
        this.items = [];
        this.totalRecords = 0;
        this.filteredRecords = 0;
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error });
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/courier-services/courier-services.component.ts